import React, { useEffect, useState } from "react";
import { Button, Col, FormGroup, Row } from "reactstrap";
import "../styles/servicebox.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ServicesItem = (props) => {
  const { data, handleOptionChange, selectedOption } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
    setTrips(data);
  }, []);
  const [trips, setTrips] = useState(data);

  return (
    <>
      <FormGroup className="booking__form d-inline-block ms-1 mb-3">
        <select
          name=""
          id=""
          value={selectedOption}
          onChange={handleOptionChange}
        >
          <option value="Pending">Pending</option>
          <option value="Active">Active</option>
          <option value="RejectedByHost">Rejected</option>
          <option value="completed">History</option>
        </select>
      </FormGroup>
      <Row>{data && data.map((item, index) => <TripsCard item={item} />)}</Row>
    </>
  );
};

const TripsCard = ({ item }) => {
  const navigate = useNavigate();
  return (
    <Col lg="4" md="4" sm="4">
      <div className="carItem">
        <div className="car__item-img ">
          <img
            src={item.imageUrl}
            alt=""
            className="w-100"
            style={{ height: "200px" }}
          />
        </div>
        <div className="car__item-content mt-4">
          <h4 className="section__title text-center">
            {item.brandName + " " + item.carName}
          </h4>
          <h6 className="rent__price text-center mt-4">
            ${item.rentPerDay}.00 <span>/ Day</span>
          </h6>
          <div className="text-center">
            {/* Add this container */}
            <Button
              className="w-50 carItem__btn carItem__btn-details"
              onClick={() =>
                navigate(
                  `/TripDetails?myObject=${encodeURIComponent(
                    JSON.stringify(item)
                  )}`
                )
              }
            >
              Details
              {/* <Link
                to={`/TripDetails/${encodeURIComponent(JSON.stringify(item))}`}
              >
                Details
              </Link> */}
            </Button>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default ServicesItem;
